import React from "react";

/**
 * Hero visual: real product photo with elegant framing & floating chips.
 */
export default function HeroVisual() {
  return (
    <div className="relative w-full max-w-[560px] mx-auto">
      <div className="relative aspect-[4/5] w-full rounded-[28px] overflow-hidden bg-brand-cloud border border-brand-mist shadow-[0_30px_80px_-30px_rgba(10,10,10,0.35)]">
        <img
          src="/images/hero.jpg"
          alt="NFC-Aufsteller von in7sekunden auf einer Empfangstheke"
          className="absolute inset-0 w-full h-full object-cover"
          loading="eager"
        />
        {/* Soft top gradient for chip readability */}
        <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-white/60 via-white/20 to-transparent pointer-events-none" />
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-ink/30 via-transparent to-transparent pointer-events-none" />

        {/* Floating chips */}
        <div className="absolute top-5 left-5 chip" data-testid="hero-chip-reviews">
          <span className="h-1.5 w-1.5 rounded-full bg-brand-ink" /> Google Review
        </div>
      </div>

      {/* Decorative ambient backdrop */}
      <div
        aria-hidden
        className="absolute -z-10 -inset-10 rounded-[40px] bg-brand-champagneSoft/30 blur-3xl"
      />
    </div>
  );
}
